// extracted by mini-css-extract-plugin
module.exports = {"container":"RestaurantSuggestionCard_container__FCSZ1","selected":"RestaurantSuggestionCard_selected__9jtvi","outletInfo":"RestaurantSuggestionCard_outletInfo__YsHG8"};